import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import _ from 'lodash';
import { PaginatorModule } from 'primeng/paginator';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { SharedModule } from '../../../shared/shared.module';
import { LoaderComponent } from '../../loader/loader.component';
import { AdministratorService } from '../../../services/administrator.service';
import { gridPageRequest, gridPagination } from '../../../model/common/common.model';
import { assignRolesGridResponse } from '../../../model/administration.model';
import { SalesService } from '../../../services/sales.service';

@Component({
  selector: 'app-assign-role-list',
  standalone: true,
  imports: [SharedModule, CommonModule,PaginatorModule,LoaderComponent],
  templateUrl: './assign-role-list.component.html',
  styleUrl: './assign-role-list.component.scss'
})
export class AssignRoleListComponent  implements OnInit {

  searchKey : any;
  selectedAssignRole: any[] = [];



  constructor(private administratorService: AdministratorService, private route: Router, private confirmationService:ConfirmationService, private messageService: MessageService,private salesService: SalesService) { }
  @ViewChild('dt1') dt1: Table | undefined;
  start: number = 0;
  rowsPerPage: number = 5;
  gridPagination: gridPagination = {
    first: 0,
    last: 0,
    totalRecords: 0
  }

  result: assignRolesGridResponse = {
    assignRole: [],
    totalRecords: 0
  }
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 50,
    id: 0
  }

  loader: boolean = false;

  ngOnInit(): void {
    document.title = 'Assign Role List';
    this.getAssignRoleInfo(this.pageRequest);
    this.searchEffect();
  }


  getAssignRoleInfo(query: gridPageRequest): void {
    this.loader = true;
    this.administratorService.getAllgetAssignRoleInfo(query).subscribe({
      next: (data: any) => {
        if (data && data.assignRole) {
          this.result = {
            ...data,
            assignRole: data.assignRole
          };
          this.pageCalculation();
        }
        this.loader = false;
      },
      error: error => {
        console.error('Error fetching company info:', error);
        this.loader = false;
      }
    });

  }


  pageCalculation() {
    // this.pageRequest.pageSize = this.rowsPerPage;
    let last = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + this.pageRequest.pageSize;
    this.gridPagination.first = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + 1;
    this.gridPagination.last = last < this.result.totalRecords ? last : this.result.totalRecords;
    this.gridPagination.totalRecords = this.result.totalRecords;
    // this.paginationLabel = _.toString(this.pageRequest.pageIndex * this.pageRequest.pageSize) + (this.result.)
  }

  CreateAssignRole() {
    this.route.navigate(['/home/assignRoles']);
  }

  editComapny(data?:any) {
    if(data){
      this.route.navigate(['/home/assignRoles'], { queryParams: { 'RoleId': data }, skipLocationChange: true },);
    }else{
      this.route.navigate(['/home/assignRoles'], { queryParams: { 'RoleId': this.selectedAssignRole[0].roleId }, skipLocationChange: true },);
    }
  }

  loadassignroleinfo(event:any){
    if (this.searchKey && this.searchKey.trim() !== '') {
      this.searchAssignRoles();
    } else {
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
      this.getAssignRoleInfo(this.pageRequest);
    }
  }

  searchAssignRoles() {
    if (!this.searchKey) {
      return;
    }
  
    this.administratorService.autosearchAssignRoles(this.searchKey).subscribe(
      (data: any) => {
        if (data) {
          this.result.assignRole = data;
          
          if (this.dt1) {
            this.dt1.first = 0;
          }
  
        } else {
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
  
refreshData(): void {
  if (this.dt1) {
    this.dt1.first = 0; 
    this.dt1.clear();
  }
  this.searchKey = ''; 
  this.pageRequest.pageIndex = 0;
  this.pageRequest.pageSize = 50; 
  this.getAssignRoleInfo(this.pageRequest); 
}


  placeholder: string = 'Search By ';
  private messages: string[] = ['Assign Role Code', 'Assign Role Name'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }

}
